import consumer from "./consumer";

class UpdateStorageSessionChannel {
  static #flagKey = 'sessionToUpdate';

  static init() {
    if (['student', 'professor'].includes(Traus.company.user.role))
      return;

    this.cable = consumer.subscriptions.create({ channel: 'UpdateSessionStorageChannel', sub_domain: Traus.company.sub_domain }, {
      received: (data) => {
        if (!data)
          return;

        localStorage.setItem(this.#flagKey, data);
      }
    });

    let storage = localStorage.getItem(this.#flagKey);
    if (!storage)
      return;

    import(/* webpackMode: "eager" */ `../storages/${storage}`)
      .then(async ({ default: storage }) => {
        await storage.update();
        UpdateStorageSessionChannel.clearFlag();
      })
      .catch((err) => {
        console.error(err);
      })
  }

  static clearFlag() {
    localStorage.removeItem(this.#flagKey);
  }
}

$(() => UpdateStorageSessionChannel.init());